module.exports = __webpack_public_path__ + "img/dangService.527205a1.png";